/* globals $ */

export default ['toolboxService', 'storyService', toolboxController]

// TODO This needs to be a directive, should not be bound here
let timer
const bindDraggable = () => {
  if (timer) {
    window.clearTimeout(timer)
  }
  if ($('#tools-list a').length) {
    $('#tools-list a').draggable({
      connectToSortable: '#story-wrapper',
      appendTo: '#story-wrapper',
      forceHelperSize: true,
      scroll: false,
      helper: function(evt) {
        const li = $(evt.currentTarget)
        const type = li.data('type')
        return `<p data-context="new-element" data-type="${type}" class="temp helper drag-view">${li.text()}</p>`
      },
      revert: true,
      revertDuration: 0,
    })
  } else {
    timer = window.setTimeout(bindDraggable, 10)
  }
}

function toolboxController(toolboxService, storyService) {
  this.$onInit = () => {}
  this.toolboxItems = []

  toolboxService.getItems().then((items) => {
    this.toolboxItems = items
    bindDraggable()
  })

  this.addItem = function($event, type) {
    $event.preventDefault()
    $event.stopPropagation()

    // TODO: move off of jquery
    $('#story-wrapper').trigger('insertNewElement', [type])

    storyService.isDirty(true)
  }
}
